import { nextfetch } from '@/shared/api/nextfetch'
import { ServerResponse } from '@/shared/types/common'

import { IpInfo } from '../model/types'

export const fetchIpInfo = async (): Promise<string | null> => {
	try {
		const res = await nextfetch<ServerResponse<IpInfo>>('ip/info', { cache: 'no-store' })
		const iso = res?.data?.country_iso_code?.trim()

		if (res?.status !== 'success' || !iso) {
			return null
		}

		return iso
	} catch {
		return null
	}
}
